import axios from 'axios';
import cookie from 'react-cookies';
import { builderSurfaceJsonContentHeader } from './restApiHeaderUtils';
import { getCookie } from '../../features/home/app_util';

export const moveDefaultCollectionFiledsToEndAndSort = (fields) => {
  const defaultFileds = [];
  const customfields = [];
  fields.map((element) => {
    if (
      ['uuid', 'createdAt', 'updatedAt', 'createdBy', 'updatedBy', 'version'].includes(
        element.fieldName,
      )
    ) {
      defaultFileds.push(element);
    } else if (element.fieldName === 'isDeleted') {
    } else {
      customfields.push(element);
    }
  });
  return [
    ...customfields.sort(dynamicSort('fieldName')),
    ...defaultFileds.sort(dynamicSort('fieldName')),
  ];
};

export const dynamicSort = (property) => {
  return (a, b) => {
    let result = 0;
    if (a[property] && b[property] && a[property] !== 'undefined' && b[property] !== 'undefined') {
      if (typeof a[property] === 'number' || typeof b[property] === 'number') {
        result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      } else {
        result =
          a[property].toLowerCase() < b[property].toLowerCase()
            ? -1
            : a[property].toLowerCase() > b[property].toLowerCase()
            ? 1
            : 0;
      }
    } else {
      result = 0;
    }

    return result;
  };
};

export const snakeCaseToTitleCase = (str, checkForUnderscore = false) => {
  if (!str) return str;
  if (typeof str === 'string' && !checkForUnderscore) {
    return str
      .toLowerCase()
      .split('_')
      .map((word) => {
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(' ');
  }
  return str;
};

export const filterByKey = (array, key, value) => {
  if (!array || !key) {
    return null;
  }
  return array.find((item) => item[key] === value);
};

export const sortAndCreateOptions = (fields) => {
  const fieldOptions = fields.sort(dynamicSort('fieldName')).map((item) => {
    return { value: item.fieldName, label: item.fieldTitle.en };
  });
  return fieldOptions;
};

export const getProtocol = () => {
  let protocol = 'https';
  let environment = process.env.REACT_APP_ENVIRONMENT || '';
  environment = environment.toLowerCase().trim();
  if (environment && environment.startsWith('dev')) {
    protocol = 'http';
  }

  return protocol;
};

export const makePostCall = async (url, body, header, type) => {
  try {
    const { data } = await axios.post(url, body, header);
    console.log('data :>> ', data);
    return data;
  } catch (error) {
    const { response, message } = error;
    if (response && response.data) {
      return { success: false, message: response.data };
    }
    if (message === 'Network Error') {
      if (type === 'PUBLISH') {
        return { success: false, message: 'Failed to publish. Please try again after sometime.' };
      }
      if (type === 'GITHUB') {
        return {
          success: false,
          message: 'Failed to push on GitHub. Please try again after sometime.',
        };
      }
      if (type === 'UPDATE') {
        return { success: false, message: 'Failed to update. Please try again after sometime.' };
      }
    }
    return { success: false, message: message || 'API call failed. Please try again later.' };
  }
};

export const trackPublish = async ({ uuid, selVersion, envType }) => {
  const builderEngineUrl = process.env.REACT_APP_BUILDER_ENGINE;
  const userIp = getCookie('userIp') || (await updateUserIpInCookie());
  const header = builderSurfaceJsonContentHeader(uuid, userIp, envType);
  const builderBody = { projectId: uuid, version: selVersion };
  makePostCall(`${builderEngineUrl}publish/savedata`, builderBody, header, 'UPDATE');
  return;
};

export const pushToGithub = async (protocol, seoName, exchangeEngineUrl, envType, uuid) => {
  const existingCookie = getCookie(`github_publish_${envType}`);

  if (existingCookie) {
    console.log('GitHub push skipped — already pushed recently');
    return { message: 'Push skipped — wait 5 minutes before retrying' };
  }

  console.log('Project is being pushed to github');
  const githubURL = `${protocol}://${seoName}.${exchangeEngineUrl}api/v1/`;
  const body = { envType };
  const header = {
    headers: {
      'Content-Type': 'application/json',
      'x-project-id': uuid,
    },
  };
  try {
    const response = await makePostCall(
      `${githubURL}github/push-to-github`,
      body,
      header,
      'GITHUB',
    );
    const expires = new Date();
    expires.setTime(expires.getTime() + 5 * 60 * 1000);
    cookie.save(`github_publish_${envType}`, 'true', { path: '/', expires });
    return response;
  } catch (err) {
    console.error('GitHub push failed', err);
    throw err;
  }
};
